module.exports = __webpack_public_path__ + "static/img/overlay-method4-9baits@2x.b277a55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/overlay-method4-9baits@2x.png
// module id = 166
// module chunks = 0